module.exports = __webpack_public_path__ + "static/antd-table-resize-346ed89b7838996efdbb31f4b0302980.gif";